import { useNavigate } from "react-router-dom";

const RouterNavigateOverride = ({ children }) => {
  History.navigate = useNavigate();
  return children;
};

export default RouterNavigateOverride;
